import { lazy } from 'react'
const CampaignCom = lazy(() => import('./Campaign'));
const ReportCom = lazy(() => import('./Report'));
export {
    CampaignCom,
    ReportCom
}